import type { ReactNode } from "react";

interface StepCardProps {
  readonly title: string;
  readonly subtitle: string;
  readonly children: ReactNode;
}

export function StepCard({ title, subtitle, children }: StepCardProps) {
  return (
    <div className="rounded-2xl border border-border bg-card px-5 py-5 space-y-4">
      <div>
        <h2 className="text-base font-semibold leading-snug">{title}</h2>
        <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>
      </div>
      {children}
    </div>
  );
}
